import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addMediaProductsToCampaign } from "@/services/rest/campaign-service";
import { AddMediaProductsToCampaignParams } from "@/types/campaign";

export const useCopyMediaProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: AddMediaProductsToCampaignParams) => {
      return await addMediaProductsToCampaign(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
};
